import React from "react";
import { Input, DatePicker, Select, Row, Col, Segmented } from "antd";
import InvoiceSmallTabs from "../Dashboard/InvoiceSmallTabs";

const { RangePicker } = DatePicker;

const InvoiceFilters = ({
                            setSearchText,
                            setSelectedSupplier,
                            setDateRange,
                            selectedStatus,
                            setSelectedStatus,
                            invoiceType,
                            setInvoiceType,
                            suppliers // 🔹 Lieferantenliste aus Dashboard erhalten
                        }) => {
    return (
        <Row gutter={[8, 8]} align="middle" wrap={false} style={{ marginBottom: "10px", overflowX: "auto" }}>
            <Col flex="auto">
                <Input placeholder="Rechnungs-Nr." onChange={(e) => setSearchText(e.target.value)} />
            </Col>
            <Col flex="auto">
                <RangePicker onChange={(dates) => setDateRange(dates)} style={{ width: "100%" }} />
            </Col>
            <Col flex="auto">
                {/* 🔹 Lieferanten-Dropdown */}
                <Select
                    placeholder="Lieferant auswählen"
                    style={{ width: "100%" }}
                    onChange={(value) => setSelectedSupplier(value)}
                    allowClear
                    showSearch
                    optionFilterProp="children"
                >
                    {suppliers.map((supplier) => (
                        <Select.Option key={supplier.id} value={supplier.name}>
                            {supplier.name}
                        </Select.Option>
                    ))}
                </Select>
            </Col>
            <Col flex="auto">
                <InvoiceSmallTabs selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus} />
            </Col>
            <Col flex="auto">
                <Segmented
                    options={[
                        { label: "Alle", value: "all" },
                        { label: "Gutschriften", value: "Gutschrift" }
                    ]}
                    value={invoiceType}
                    onChange={setInvoiceType}
                    style={{ width: "100%" }}
                />
            </Col>
        </Row>
    );
};

export default InvoiceFilters;